import { render, staticRenderFns } from "./DialogEditClientPortfolio.vue?vue&type=template&id=1dbb061b"
import script from "./DialogEditClientPortfolio.vue?vue&type=script&lang=js"
export * from "./DialogEditClientPortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports